/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "uz-Arab": {
        "nu": ["arabext"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "year-narrow": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-narrow": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "month-narrow": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "week-narrow": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        }
      },
      "uz-Cyrl": {
        "year": {
          "0": "бу йил",
          "1": "кейинги йил",
          "future": {
            "one": "{0} йилдан сўнг",
            "other": "{0} йилдан сўнг"
          },
          "past": {
            "one": "{0} йил аввал",
            "other": "{0} йил аввал"
          },
          "-1": "ўтган йил"
        },
        "year-short": {
          "0": "бу йил",
          "1": "кейинги йил",
          "future": {
            "one": "{0} йилдан сўнг",
            "other": "{0} йилдан сўнг"
          },
          "past": {
            "one": "{0} йил аввал",
            "other": "{0} йил аввал"
          },
          "-1": "ўтган йил"
        },
        "year-narrow": {
          "0": "бу йил",
          "1": "кейинги йил",
          "future": {
            "one": "{0} йилдан сўнг",
            "other": "{0} йилдан сўнг"
          },
          "past": {
            "one": "{0} йил аввал",
            "other": "{0} йил аввал"
          },
          "-1": "ўтган йил"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-narrow": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "month": {
          "0": "бу ой",
          "1": "кейинги ой",
          "future": {
            "one": "{0} ойдан сўнг",
            "other": "{0} ойдан сўнг"
          },
          "past": {
            "one": "{0} ой аввал",
            "other": "{0} ой аввал"
          },
          "-1": "ўтган ой"
        },
        "month-short": {
          "0": "бу ой",
          "1": "кейинги ой",
          "future": {
            "one": "{0} ойдан сўнг",
            "other": "{0} ойдан сўнг"
          },
          "past": {
            "one": "{0} ой аввал",
            "other": "{0} ой аввал"
          },
          "-1": "ўтган ой"
        },
        "month-narrow": {
          "0": "бу ой",
          "1": "кейинги ой",
          "future": {
            "one": "{0} ойдан сўнг",
            "other": "{0} ойдан сўнг"
          },
          "past": {
            "one": "{0} ой аввал",
            "other": "{0} ой аввал"
          },
          "-1": "ўтган ой"
        },
        "week": {
          "0": "бу ҳафта",
          "1": "кейинги ҳафта",
          "future": {
            "one": "{0} ҳафтадан сўнг",
            "other": "{0} ҳафтадан сўнг"
          },
          "past": {
            "one": "{0} ҳафта олдин",
            "other": "{0} ҳафта олдин"
          },
          "-1": "ўтган ҳафта"
        },
        "week-short": {
          "0": "бу ҳафта",
          "1": "кейинги ҳафта",
          "future": {
            "one": "{0} ҳафтадан сўнг",
            "other": "{0} ҳафтадан сўнг"
          },
          "past": {
            "one": "{0} ҳафта олдин",
            "other": "{0} ҳафта олдин"
          },
          "-1": "ўтган ҳафта"
        },
        "week-narrow": {
          "0": "бу ҳафта",
          "1": "кейинги ҳафта",
          "future": {
            "one": "{0} ҳафтадан сўнг",
            "other": "{0} ҳафтадан сўнг"
          },
          "past": {
            "one": "{0} ҳафта олдин",
            "other": "{0} ҳафта олдин"
          },
          "-1": "ўтган ҳафта"
        },
        "day": {
          "0": "бугун",
          "1": "эртага",
          "future": {
            "one": "{0} кундан сўнг",
            "other": "{0} кундан сўнг"
          },
          "past": {
            "one": "{0} кун олдин",
            "other": "{0} кун олдин"
          },
          "-1": "кеча"
        },
        "day-short": {
          "0": "бугун",
          "1": "эртага",
          "future": {
            "one": "{0} кундан сўнг",
            "other": "{0} кундан сўнг"
          },
          "past": {
            "one": "{0} кун олдин",
            "other": "{0} кун олдин"
          },
          "-1": "кеча"
        },
        "day-narrow": {
          "0": "бугун",
          "1": "эртага",
          "future": {
            "one": "{0} кундан сўнг",
            "other": "{0} кундан сўнг"
          },
          "past": {
            "one": "{0} кун олдин",
            "other": "{0} кун олдин"
          },
          "-1": "кеча"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "one": "{0} соатдан сўнг",
            "other": "{0} соатдан сўнг"
          },
          "past": {
            "one": "{0} соат олдин",
            "other": "{0} соат олдин"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "one": "{0} соатдан сўнг",
            "other": "{0} соатдан сўнг"
          },
          "past": {
            "one": "{0} соат олдин",
            "other": "{0} соат олдин"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "one": "{0} соатдан сўнг",
            "other": "{0} соатдан сўнг"
          },
          "past": {
            "one": "{0} соат олдин",
            "other": "{0} соат олдин"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "one": "{0} дақиқадан сўнг",
            "other": "{0} дақиқадан сўнг"
          },
          "past": {
            "one": "{0} дақиқа олдин",
            "other": "{0} дақиқа олдин"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "one": "{0} дақиқадан сўнг",
            "other": "{0} дақиқадан сўнг"
          },
          "past": {
            "one": "{0} дақиқа олдин",
            "other": "{0} дақиқа олдин"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "one": "{0} дақиқадан сўнг",
            "other": "{0} дақиқадан сўнг"
          },
          "past": {
            "one": "{0} дақиқа олдин",
            "other": "{0} дақиқа олдин"
          }
        },
        "second": {
          "0": "ҳозир",
          "future": {
            "one": "{0} сониядан сўнг",
            "other": "{0} сониядан сўнг"
          },
          "past": {
            "one": "{0} сония олдин",
            "other": "{0} сония олдин"
          }
        },
        "second-short": {
          "0": "ҳозир",
          "future": {
            "one": "{0} сониядан сўнг",
            "other": "{0} сониядан сўнг"
          },
          "past": {
            "one": "{0} сония олдин",
            "other": "{0} сония олдин"
          }
        },
        "second-narrow": {
          "0": "ҳозир",
          "future": {
            "one": "{0} сониядан сўнг",
            "other": "{0} сониядан сўнг"
          },
          "past": {
            "one": "{0} сония олдин",
            "other": "{0} сония олдин"
          }
        }
      },
      "uz": {
        "nu": ["latn"],
        "year": {
          "0": "shu yil",
          "1": "keyingi yil",
          "future": {
            "one": "{0} yildan keyin",
            "other": "{0} yildan keyin"
          },
          "past": {
            "one": "{0} yil oldin",
            "other": "{0} yil oldin"
          },
          "-1": "o‘tgan yil"
        },
        "year-short": {
          "0": "bu yil",
          "1": "keyingi yil",
          "future": {
            "one": "{0} yildan keyin",
            "other": "{0} yildan keyin"
          },
          "past": {
            "one": "{0} yil oldin",
            "other": "{0} yil oldin"
          },
          "-1": "o‘ʻtgan yil"
        },
        "year-narrow": {
          "0": "bu yil",
          "1": "keyingi yil",
          "future": {
            "one": "{0} yildan keyin",
            "other": "{0} yildan keyin"
          },
          "past": {
            "one": "{0} yil oldin",
            "other": "{0} yil oldin"
          },
          "-1": "o‘tgan yil"
        },
        "quarter": {
          "0": "shu chorak",
          "1": "keyingi chorak",
          "future": {
            "one": "{0} chorakdan keyin",
            "other": "{0} chorakdan keyin"
          },
          "past": {
            "one": "{0} chorak oldin",
            "other": "{0} chorak oldin"
          },
          "-1": "o‘tgan chorak"
        },
        "quarter-short": {
          "0": "shu chorak",
          "1": "keyingi chorak",
          "future": {
            "one": "{0} chorakdan keyin",
            "other": "{0} chorakdan keyin"
          },
          "past": {
            "one": "{0} chorak oldin",
            "other": "{0} chorak oldin"
          },
          "-1": "o‘tgan chorak"
        },
        "quarter-narrow": {
          "0": "shu chorak",
          "1": "keyingi chorak",
          "future": {
            "one": "{0} chorakdan keyin",
            "other": "{0} chorakdan keyin"
          },
          "past": {
            "one": "{0} chorak oldin",
            "other": "{0} chorak oldin"
          },
          "-1": "o‘tgan chorak"
        },
        "month": {
          "0": "shu oy",
          "1": "keyingi oy",
          "future": {
            "one": "{0} oydan keyin",
            "other": "{0} oydan keyin"
          },
          "past": {
            "one": "{0} oy oldin",
            "other": "{0} oy oldin"
          },
          "-1": "o‘tgan oy"
        },
        "month-short": {
          "0": "bu oy",
          "1": "keyingi oy",
          "future": {
            "one": "{0} oydan keyin",
            "other": "{0} oydan keyin"
          },
          "past": {
            "one": "{0} oy oldin",
            "other": "{0} oy oldin"
          },
          "-1": "o‘tgan oy"
        },
        "month-narrow": {
          "0": "bu oy",
          "1": "keyingi oy",
          "future": {
            "one": "{0} oydan keyin",
            "other": "{0} oydan keyin"
          },
          "past": {
            "one": "{0} oy oldin",
            "other": "{0} oy oldin"
          },
          "-1": "o‘tgan oy"
        },
        "week": {
          "0": "shu hafta",
          "1": "keyingi hafta",
          "future": {
            "one": "{0} haftadan keyin",
            "other": "{0} haftadan keyin"
          },
          "past": {
            "one": "{0} hafta oldin",
            "other": "{0} hafta oldin"
          },
          "-1": "o‘tgan hafta"
        },
        "week-short": {
          "0": "bu hafta",
          "1": "keyingi hafta",
          "future": {
            "one": "{0} haftadan keyin",
            "other": "{0} haftadan keyin"
          },
          "past": {
            "one": "{0} hafta oldin",
            "other": "{0} hafta oldin"
          },
          "-1": "o‘tgan hafta"
        },
        "week-narrow": {
          "0": "bu hafta",
          "1": "keyingi hafta",
          "future": {
            "one": "{0} haftadan keyin",
            "other": "{0} haftadan keyin"
          },
          "past": {
            "one": "{0} hafta oldin",
            "other": "{0} hafta oldin"
          },
          "-1": "o‘tgan hafta"
        },
        "day": {
          "0": "bugun",
          "1": "ertaga",
          "future": {
            "one": "{0} kundan keyin",
            "other": "{0} kundan keyin"
          },
          "past": {
            "one": "{0} kun oldin",
            "other": "{0} kun oldin"
          },
          "-1": "kecha"
        },
        "day-short": {
          "0": "bugun",
          "1": "ertaga",
          "future": {
            "one": "{0} kundan keyin",
            "other": "{0} kundan keyin"
          },
          "past": {
            "one": "{0} kun oldin",
            "other": "{0} kun oldin"
          },
          "-1": "kecha"
        },
        "day-narrow": {
          "0": "bugun",
          "1": "ertaga",
          "future": {
            "one": "{0} kundan keyin",
            "other": "{0} kundan keyin"
          },
          "past": {
            "one": "{0} kun oldin",
            "other": "{0} kun oldin"
          },
          "-1": "kecha"
        },
        "hour": {
          "0": "shu soatda",
          "future": {
            "one": "{0} soatdan keyin",
            "other": "{0} soatdan keyin"
          },
          "past": {
            "one": "{0} soat oldin",
            "other": "{0} soat oldin"
          }
        },
        "hour-short": {
          "0": "shu soatda",
          "future": {
            "one": "{0} soatdan keyin",
            "other": "{0} soatdan keyin"
          },
          "past": {
            "one": "{0} soat oldin",
            "other": "{0} soat oldin"
          }
        },
        "hour-narrow": {
          "0": "shu soatda",
          "future": {
            "one": "{0} soatdan keyin",
            "other": "{0} soatdan keyin"
          },
          "past": {
            "one": "{0} soat oldin",
            "other": "{0} soat oldin"
          }
        },
        "minute": {
          "0": "shu daqiqada",
          "future": {
            "one": "{0} daqiqadan keyin",
            "other": "{0} daqiqadan keyin"
          },
          "past": {
            "one": "{0} daqiqa oldin",
            "other": "{0} daqiqa oldin"
          }
        },
        "minute-short": {
          "0": "shu daqiqada",
          "future": {
            "one": "{0} daqiqadan keyin",
            "other": "{0} daqiqadan keyin"
          },
          "past": {
            "one": "{0} daqiqa oldin",
            "other": "{0} daqiqa oldin"
          }
        },
        "minute-narrow": {
          "0": "shu daqiqada",
          "future": {
            "one": "{0} daqiqadan keyin",
            "other": "{0} daqiqadan keyin"
          },
          "past": {
            "one": "{0} daqiqa oldin",
            "other": "{0} daqiqa oldin"
          }
        },
        "second": {
          "0": "hozir",
          "future": {
            "one": "{0} soniyadan keyin",
            "other": "{0} soniyadan keyin"
          },
          "past": {
            "one": "{0} soniya oldin",
            "other": "{0} soniya oldin"
          }
        },
        "second-short": {
          "0": "hozir",
          "future": {
            "one": "{0} soniyadan keyin",
            "other": "{0} soniyadan keyin"
          },
          "past": {
            "one": "{0} soniya oldin",
            "other": "{0} soniya oldin"
          }
        },
        "second-narrow": {
          "0": "hozir",
          "future": {
            "one": "{0} soniyadan keyin",
            "other": "{0} soniyadan keyin"
          },
          "past": {
            "one": "{0} soniya oldin",
            "other": "{0} soniya oldin"
          }
        }
      }
    },
    "availableLocales": ["uz-Arab", "uz-Cyrl", "uz-Latn", "uz"],
    "aliases": {
      "uz-AF": "uz-Arab-AF",
      "uz-UZ": "uz-Latn-UZ"
    },
    "parentLocales": {}
  });
}